import { findIndex, unionWith, cloneDeep } from "lodash"
//import sendxAPI from '../../../xAPI'

const templateState = {
  heldObject: {
    type: null,
    id: -1,
    htmlObj: null,
  },
  targetList: [],
  notebookExpanded: true,
  lastDrop: {
    lastHeld: null,
    lastTarget: null
  },
  modal: {
    display: false,
    type: null,
    size: 'sm',
    connect: -1,
    shown: [],
    data: null
  },

  // TODO: Remove the predication state
  gelDragDropPrediction: {
    "DNA Ladder": [100, 300, 500, 800, 1000],
    "Sample": [-55, -55],
    "Control 1": [-55, -55],
    "Control 2": [-55, -55],
    "Control 3": [-55, -55],
    "Control 4": [-55, -55]
  },
  apparatus: {},
  interactions: [],
  sceneScale: [],
  sceneScale: 1,
  userScale: 1,

  /// --------------- ///
  currentProtocolPage: 1,
  totalProtocolPages: 99,
  currentPageInstructions: "",
  taskPages: [],
  level: 1,
  focusedPage: -1,
  focusedTask: -1,
  focusedTaskObj: {},
  lastActions: {},
  tempPoints: 0,

  /// --------------- ///

  undo: {
    snapshots: {},
    attempts: 3
  },

  // TODO: Remove the animation state
  /// --------------- ///
  prepareGelBox: false,
  loadDNALadder: false,
  runGel: false,
  visualizeGel: false,
  run12hours: false,
  rotateCuvette: false,
  holdCuvette: false,
  setupComplete: false,

  /// ------------- //
  labelReactionTubes: false,
  viewedProtocolReadDialog: false,
  moveMenu: {
    display: false,
    type: null,
    connect: -1
  }
};

export function ProtocolReducer(state = {}, action) {
  console.log(state)
  let protocolSection = state.protocolSection;
  let actionObj = {
        type: action.type,
        payload: action.payload
    }

  if (action.payload === undefined) {
      return state;
  }

  switch (action.type) {

      case 'SET_UUID':

        protocolSection.uuid = action.payload;

        return { ...state, ...{
          protocolSection: protocolSection
        } }

      case 'SETUP_PROTOCOL_SCENE':

        //Create new obj from template state
        let newObj = { ...templateState, ...action.payload.props }

        if(!protocolSection.scene.hasOwnProperty("apparatus")){
          protocolSection.scene = {...protocolSection.scene, ...newObj}
        }

        console.log(state)

        return { ...state, ...{
          protocolSection: protocolSection
        } }

      case 'LOAD_DNA_LADDER':

        //Create new obj
        protocolSection.loadDNALadder = action.payload;
        protocolSection.scene.lastActions = addAction(actionObj);

        return { ...state, ...{
          protocolSection: protocolSection
        } }

      case 'VIEWED_PROTOCOL_READ_DIALOG':

        //Create new obj
        protocolSection.scene.viewedProtocolReadDialog = action.payload.viewedProtocolReadDialog;
        protocolSection.scene.lastActions = addAction(actionObj);

        return { ...state, ...{
          protocolSection: protocolSection
        } }

      case 'RE_LABEL_REACTION_TUBES':
        //Create new obj
        protocolSection.scene.labelReactionTubes = action.payload.labelReactionTubes;
        protocolSection.scene.lastActions = addAction(actionObj);

        return { ...state, ...{
          protocolSection: protocolSection
        } }

      case 'PREPARE_GELBOX':

        //Create new obj
        protocolSection.prepareGelBox = action.payload;
        protocolSection.scene.lastActions = addAction(actionObj);

        return { ...state, ...{
          protocolSection: protocolSection
        } }

      case 'SETUP_COMPLETE':

        //Create new obj
        protocolSection.scene.setupComplete = action.payload;
        protocolSection.scene.lastActions = addAction(actionObj);

        return { ...state, ...{
          protocolSection: protocolSection
        } }

      case 'ROTATE_CUVETTE':

        //Create new obj
        protocolSection.scene.rotateCuvette = action.payload;
        protocolSection.scene.lastActions = addAction(actionObj);

        return { ...state, ...{
          protocolSection: protocolSection
        } }

      case 'HOLD_CUVETTE':

        //Create new obj
        protocolSection.scene.holdCuvette = action.payload;
        protocolSection.scene.lastActions = addAction(actionObj);

        return { ...state, ...{
          protocolSection: protocolSection
        } }

      case 'RUN_12_HOURS':

        //Create new obj
        protocolSection.scene.run12hours = action.payload.run12hours;
        protocolSection.scene.lastActions = addAction(actionObj);

        return { ...state, ...{
          protocolSection: protocolSection
        } }

      case 'RUN_GEL':

        //Create new obj
        protocolSection.runGel = action.payload;
        protocolSection.scene.lastActions = addAction(actionObj);

        return { ...state, ...{
          protocolSection: protocolSection
        } }

      case 'VISUALIZE_GEL':

        //Create new obj
        protocolSection.visualizeGel = action.payload;
        protocolSection.scene.lastActions = addAction(actionObj);

        return { ...state, ...{
          protocolSection: protocolSection
        } }

      case 'ROTATE_CUVETTE':

        //Create new obj
        protocolSection.rotateCuvette = action.payload;
        protocolSection.scene.lastActions = addAction(actionObj);

        return { ...state, ...{
          protocolSection: protocolSection
        } }

      case 'PUT_ON_PPE':

        //Create new obj
        protocolSection.putOnPPE = action.payload;
        protocolSection.scene.lastActions = addAction(actionObj);

        return { ...state, ...{
          protocolSection: protocolSection
        } }

      case 'MASTER_MIX_POSTER':

        //Create new obj
        protocolSection.masterMixPoster = action.payload;
        protocolSection.scene.lastActions = addAction(actionObj);

        return { ...state, ...{
          protocolSection: protocolSection
        } }

      case 'THERMOCYCLER_POSTER':

        //Create new obj
        protocolSection.thermocyclerPoster = action.payload;
        protocolSection.scene.lastActions = addAction(actionObj);

        return { ...state, ...{
          protocolSection: protocolSection
        } }

      case 'RUN_THERMOCYCLER':

        //Create new obj
        protocolSection.runThermocycler = action.payload;
        protocolSection.scene.lastActions = addAction(actionObj);

        return { ...state, ...{
          protocolSection: protocolSection
        } }

      case 'SET_PROTOCOL_TABLE_DATA':

        //Create new obj
        protocolSection.scene.lastActions = addAction(actionObj);
        let tableData = action.payload.tableData;
        tableData.submitted = true;
        protocolSection.tableData = tableData;

        return { ...state, ...{
          protocolSection: protocolSection
        } }

      case 'SET_TABLE_QUESTION_DATA':

        //Create new obj
        protocolSection.scene.lastActions = addAction(actionObj);
        protocolSection.tableData2 = action.payload.tableData

        return { ...state, ...{
          protocolSection: protocolSection
        } }

      case "SET_POPUP_FIRED":
        let tempTask2 = cloneDeep(protocolSection.scene.focusedTaskObj)
        if(!tempTask2.hasOwnProperty("popups")){

          protocolSection.scene.lastActions = addAction(actionObj);
          return { ...state, ...{
            protocolSection: protocolSection
          } }

        }

       tempTask2.popups[action.payload.index].fired = true;

        protocolSection.scene.focusedTaskObj = tempTask2;
        protocolSection.scene.lastActions = addAction(actionObj);

        return { ...state, ...{
          protocolSection: protocolSection
        } }

      case 'SET_HELD_OBJECT':

          protocolSection.scene.heldObject = action.payload;
          console.log(action.payload);
          console.log("============================");

          return { ...state, ...{
            protocolSection: protocolSection
          } }

      case 'SAVE_GEL_DRAGDROP_PREDICTION':
          protocolSection.scene.gelDragDropPrediction = action.payload;

          return { ...state, ...{
            protocolSection: protocolSection
          } }

      case 'SET_TARGET_LIST':

          protocolSection.scene.targetList = action.payload;

          return { ...state, ...{
            protocolSection: protocolSection
          } }

      case 'PUSH_INTERACTIONS':

      protocolSection.scene.interactions = [ ...unionWith(protocolSection.scene.interactions, action.payload, function(a, b){
         if(a.name === b.name){
           return true
         } else {
           return false;
         }
       } ) ]

      return { ...state, ...{
        protocolSection: protocolSection
      } }

      case 'SET_LAST_DROP':

       if(action.payload.lastHeld !== null &&
          action.payload.lastHeld.type !== null &&
          action.payload.lastTarget !== null &&
          action.payload.lastTarget.type !== null){

       }

       protocolSection.scene.lastActions = addAction(actionObj);
       protocolSection.scene.lastDrop = action.payload;

       return { ...state, ...{
         protocolSection: protocolSection
       } }

      /// ------------------------------- ///

      case "NOTES_VIEW":

        protocolSection.scene.notesView = action.payload;
        protocolSection.scene.lastActions = addAction(actionObj);

        return { ...state, ...{
          protocolSection: protocolSection
        } }

      case "INC_PROTOCOL_PAGE":
          if ((protocolSection.scene.currentProtocolPage + action.payload) <= protocolSection.scene.totalProtocolPages) {

              protocolSection.scene.currentProtocolPage = protocolSection.scene.currentProtocolPage + action.payload;
              protocolSection.scene.lastActions = addAction(actionObj);

              return { ...state, ...{
                protocolSection: protocolSection
              } }

          } else {

              protocolSection.scene.sectionSelected = 'Results';
              protocolSection.scene.lastActions = addAction(actionObj);

              return { ...state, ...{
                protocolSection: protocolSection
              } }
          }

      case "DEC_PROTOCOL_PAGE":
          if ((protocolSection.scene.currentProtocolPage - action.payload) >= 1) {

              protocolSection.scene.currentProtocolPage = protocolSection.scene.currentProtocolPage - action.payload;
              protocolSection.scene.lastActions = addAction(actionObj);

              return { ...state, ...{
                protocolSection: protocolSection
              } }

          } else {

            protocolSection.scene.lastActions = addAction(actionObj);

            return { ...state, ...{
              protocolSection: protocolSection
            } }
          }

      case "GO_PROTOCOL_PAGE":
          if (action.payload >= 1 && action.payload <= protocolSection.scene.totalProtocolPages) {

               protocolSection.scene.currentProtocolPage = action.payload;
               protocolSection.scene.lastActions = addAction(actionObj);

               return { ...state, ...{
                 protocolSection: protocolSection
               } }

          } else {

            protocolSection.scene.lastActions = addAction(actionObj);

            return { ...state, ...{
              protocolSection: protocolSection
            } }

          }

      case "SET_TOTAL_PROTOCOL_PAGES":

          protocolSection.scene.totalProtocolPages = action.payload;
          protocolSection.scene.lastActions = addAction(actionObj);

          return { ...state, ...{
            protocolSection: protocolSection
          } }

      case "SET_PAGE_INSTRUCTIONS":
          //Set current page instructions
           protocolSection.scene.currentPageInstructions = action.payload;
           protocolSection.scene.lastActions = addAction(actionObj);

           return { ...state, ...{
             protocolSection: protocolSection
           } }

      case "SET_TASK_PAGES":
          //Set all task pages data on init
          protocolSection.scene.taskPages = action.payload;
          protocolSection.scene.lastActions = addAction(actionObj);

          return { ...state, ...{
            protocolSection: protocolSection
          } }

      case "SET_LEVEL":

          // xAPI statement
          // sendxAPI({
          //   // Type of statement
          //   verb: {
          //     description: "assigned",
          //     address: "https://w3id.org/xapi/dod-isd/verbs/assigned"
          //   },
          //   // Where the action occured
          //   context: "Level",
          //   // Result of the action
          //   result: {
          //     success: true,
          //     response: action.payload.level
          //   }
          // })

          protocolSection.scene.level = action.payload.level;
          protocolSection.scene.lastActions = addAction(actionObj);

          return { ...state, ...{
            protocolSection: protocolSection
          } }

      case "FOCUS_FIRST_TASK":
          //Sets first task on first page to focused
          return startFirstTask();

      case "SET_TASK_COMPLETED":

          // xAPI statement
          // sendxAPI({
          //   // Type of statement
          //   verb: {
          //     description: "completed",
          //     address: "https://w3id.org/xapi/dod-isd/verbs/completed"
          //   },
          //   // Where the action occured
          //   context: "Protocol task: "+state.focusedTaskObj.levels["l"+state.level].task,
          //   // Result of the action
          //   result: {
          //     success: true,
          //     response: true
          //   }
          // })

          //Sets focused task as completed
          return taskCompleted();

      case "CLEAR_LAST_ACTIONS":

        protocolSection.scene.lastActions = {};

        return { ...state, ...{
          protocolSection: protocolSection
        } }

      case "CLEAR_TEMP_POINTS":

          protocolSection.scene.tempPoints = 0;
          protocolSection.scene.lastActions = addAction(actionObj);

          return { ...state, ...{
            protocolSection: protocolSection
          } }

      case "INC_TEMP_POINTS":

        protocolSection.scene.tempPoints = protocolSection.scene.tempPoints + 1;
        protocolSection.scene.lastActions = addAction(actionObj);

        return { ...state, ...{
          protocolSection: protocolSection
        } }

      case "SET_TOAST_FIRED":

          let tempTask = cloneDeep(protocolSection.scene.focusedTaskObj)
          if(!tempTask.levels["l"+state.level].hasOwnProperty("hints")){

              protocolSection.scene.lastActions = addAction(actionObj);

              return { ...state, ...{
                protocolSection: protocolSection
              } }

          }
          tempTask.levels["l"+state.level].hints.forEach(hint => {
              hint.fired = true
          });

          // xAPI statement
           // sendxAPI({
           //   // Type of statement
           //   verb: {
           //     description: "viewed",
           //     address: "http://id.tincanapi.com/verb/viewed"
           //   },
           //   // Where the action occured
           //   context: "Protocol task hint: "+tempTask.levels["l"+state.level].hints[0].msg,
           //   // Result of the action
           //   result: {
           //     success: true,
           //     response: true
           //   }
           // })

           protocolSection.scene.focusedTaskObj = tempTask;
           protocolSection.scene.lastActions = addAction(actionObj);

           return { ...state, ...{
             protocolSection: protocolSection
           } }


      case "SAVE_TASK_NOTE":

      // TODO: We pass the context of the task page, and index back in
      // & and rebuild those items into the data set
      // Makes sense to extend the task pages -> task page -> task to
      // seperate reducers
          let tempTasks = cloneDeep(protocolSection.scene.taskPages)
          tempTasks[action.payload.page].tasks[action.payload.index].notes.push(action.payload.note)

          // xAPI statement
          // sendxAPI({
          //   // Type of statement
          //   verb: {
          //     description: "saved",
          //     address: "https://w3id.org/xapi/dod-isd/verbs/saved"
          //   },
          //   // Where the action occured
          //   context: "Observation",
          //   // Result of the action
          //   result: {
          //     success: true,
          //     response: action.payload.note
          //   }
          // })

          //Sync task back into taskTasks array
           protocolSection.scene.taskPages = tempTasks;
           protocolSection.scene.lastActions = addAction(actionObj);

           return { ...state, ...{
             protocolSection: protocolSection
           } }


      case "SET_TASK_COMPLETED":
          let tempPages = cloneDeep(protocolSection.scene.taskPages)
          const tI = action.payload.taskIndex
          const pI = action.payload.pageIndex
          //find task at pageIndex, taskIndex
          //change task to complete=true
          tempPages[pI].tasks[tI].complete = true
          tempPages[pI].tasks[tI].current = false
          if(tempPages[pI].tasks.length > tI+1){
              tempPages[pI].tasks[tI+1].current = true
          }
          //Sync task back into taskPages array
           protocolSection.scene.taskPages = tempPages;
           protocolSection.scene.lastActions = addAction(actionObj);

           return { ...state, ...{
             protocolSection: protocolSection
           } }

      case "UNDO":
          //Payload = {lastState}
          if (action.payload.lastState !== null) {
            let newProtocolSection = {...protocolSection, ...cloneDeep(action.payload.lastState)};
            newProtocolSection.scene.undo = protocolSection.scene.undo;
            newProtocolSection.scene.lastActions = {};

            return { ...state, ...{
              protocolSection: newProtocolSection
            } }
          } else {
            return state;
          }


      /// ------------------------------- ///


       case 'SET_SCENE_SCALE':

           // xAPI statement
           // sendxAPI({
           //   // Type of statement
           //   verb: {
           //     description: "assigned",
           //     address: "http://id.tincanapi.com/verb/assigned"
           //   },
           //   // Where the action occured
           //   context: 'Scene scale',
           //   // Result of the action
           //   result: {
           //     success: true,
           //     response: action.payload.scale
           //   }
           // })

           return { ...state, ...{ sceneScale: action.payload.scale } }

       case 'SET_USER_SCALE':

           // xAPI statement
           // sendxAPI({
           //   // Type of statement
           //   verb: {
           //     description: "assigned",
           //     address: "http://id.tincanapi.com/verb/assigned"
           //   },
           //   // Where the action occured
           //   context: 'Scene scale',
           //   // Result of the action
           //   result: {
           //     success: true,
           //     response: action.payload.scale
           //   }
           // })

           return { ...state, ...{ userScale: action.payload.scale } }

      /// -------------------------------MOVE MENU ///
      case 'SET_MOVEMENU':
        if(protocolSection.scene.hasOwnProperty("moveMenu")){
          protocolSection.scene.moveMenu = {...protocolSection.scene.moveMenu, ...action.payload}
        }
        return { ...state, ...{
          protocolSection: protocolSection
        } }

      case 'SHOW_MOVEMENU':
        if(protocolSection.scene.hasOwnProperty("moveMenu")){
          protocolSection.scene.moveMenu = { ...protocolSection.scene.moveMenu, ...{ display: action.payload.display } }
        }
        return { ...state, ...{
          protocolSection: protocolSection
        } }

       default:
          console.log(protocolSection)
          if(protocolSection.scene.hasOwnProperty('lastActions')){
            protocolSection.scene.lastActions = addAction(actionObj);

            return { ...state, ...{
              protocolSection: protocolSection
            } }
          } else {
            return state
          }

  }


    function addAction(action) {

        let tempActions = cloneDeep(protocolSection.scene.lastActions)
        //Only add actions if not already in collection
        if (!tempActions.hasOwnProperty(action.type)) {
            //Set to 1 if first time adding this action
            tempActions[action.type] = 1
        }
        return tempActions
    }

    function taskCompleted() {
        //If on last task of page
        if (protocolSection.scene.taskPages[protocolSection.scene.focusedPage].tasks.length === protocolSection.scene.focusedTask + 1) {
            //Check isn't on last page
            if (protocolSection.scene.taskPages.length > protocolSection.scene.focusedPage + 1) {
                //End of page, set next page to focus
                const tempObj = cloneDeep(protocolSection.scene.taskPages[protocolSection.scene.focusedPage + 1].tasks[0])
                let tempPages = cloneDeep(protocolSection.scene.taskPages)
                tempPages[protocolSection.scene.focusedPage].tasks[protocolSection.scene.focusedTask].complete = true
                tempPages[protocolSection.scene.focusedPage].tasks[protocolSection.scene.focusedTask].current = false
                tempPages[protocolSection.scene.focusedPage+1].tasks[0].current = true
                tempPages[protocolSection.scene.focusedPage].complete = true

                // Save changes
                protocolSection.scene.taskPages = tempPages
                protocolSection.scene.focusedTask = 0
                protocolSection.scene.focusedTaskObj = tempObj
                protocolSection.scene.focusedPage = protocolSection.scene.focusedPage + 1
                protocolSection.scene.lastActions = addAction(actionObj)

                return { ...state, ...{
                  protocolSection: protocolSection
                } }


            } else {
                //If on last page --> just set current task to complete and not current
                let tempPages = cloneDeep(protocolSection.scene.taskPages)
                tempPages[protocolSection.scene.focusedPage].tasks[protocolSection.scene.focusedTask].complete = true
                tempPages[protocolSection.scene.focusedPage].tasks[protocolSection.scene.focusedTask].current = false
                tempPages[protocolSection.scene.focusedPage].complete = true

                protocolSection.scene.taskPages = tempPages
                protocolSection.scene.lastActions = addAction(actionObj)

                return { ...state, ...{
                  protocolSection: protocolSection
                } }
            }
        } else {
            //If task is not last task on page
            const tempObj = cloneDeep(protocolSection.scene.taskPages[protocolSection.scene.focusedPage].tasks[protocolSection.scene.focusedTask + 1])
            let tempPages = cloneDeep(protocolSection.scene.taskPages)
            tempPages[protocolSection.scene.focusedPage].tasks[protocolSection.scene.focusedTask].complete = true
            tempPages[protocolSection.scene.focusedPage].tasks[protocolSection.scene.focusedTask].current = false
            tempPages[protocolSection.scene.focusedPage].tasks[protocolSection.scene.focusedTask+1].current = true


            protocolSection.scene.taskPages = tempPages
            protocolSection.scene.focusedTask = protocolSection.scene.focusedTask + 1
            protocolSection.scene.focusedTaskObj = tempObj
            protocolSection.scene.lastActions = addAction(actionObj)

            return { ...state, ...{
              protocolSection: protocolSection
            } }
        }
    }

    //TODO Update this to find next uncompleted task from tasks array
    function startFirstTask() {
        //Sets first task as focused once data loaded
        if (protocolSection.scene.taskPages.length > 0) {
            const tempObj = cloneDeep(protocolSection.scene.taskPages[0].tasks[0])

            protocolSection.scene.focusedTask = 0
            protocolSection.scene.focusedPage = 0
            protocolSection.scene.focusedTaskObj = tempObj
            protocolSection.scene.lastActions = addAction(actionObj)

            return { ...state, ...{
              protocolSection: protocolSection
            } }

        }

        protocolSection.scene.lastActions = addAction(actionObj)

        return { ...state, ...{
          protocolSection: protocolSection
        } }
    }
}
